import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AuthService } from 'src/app/services/auth.service';
import Swal from 'sweetalert2';
import { ShopService } from '../../services/shop.service';

@Component({
  selector: 'app-response-payu',
  templateUrl: './response-payu.component.html',
  styleUrls: ['./response-payu.component.scss']
})
export class ResponsePayuComponent implements OnInit {

  perfilUser: any;
  idUser: string;
  referencia: number;
  resultado: any;
  carrito = [];

  public user = this.authSvc.afAuth.user;

  constructor(private activatedRoute: ActivatedRoute,
              private shopSvc: ShopService,
              private authSvc: AuthService) { }

  ngOnInit(): void {
    this.user.subscribe(resp => {
      this.perfilUser = resp;
      this.idUser = this.perfilUser.uid;
      // console.log('id de usuario: ', this.idUser);
      this.referencia = Number(this.activatedRoute.snapshot.queryParams.referenceCode);
      const refer = Number(this.referencia);
      // console.log('ref de compra: ', refer);
      this.shopSvc.validateSale(refer).subscribe(res => {
        this.resultado = res;
        const id = this.resultado[0].id;
        // console.log(this.resultado);
        if (this.activatedRoute.snapshot.queryParams.transactionState === '4'){
          this.shopSvc.updateSaleAccepted(id).then( resultado => {
            Swal.fire({
              title: 'Venta realizada',
              text: 'El pedido fué enviado correctamente',
              icon: 'success',
              allowOutsideClick: false,
              showCloseButton: true
            });
            this.updateLocalStorage();
          });
        }
        if (this.activatedRoute.snapshot.queryParams.transactionState === '6') {
          this.shopSvc.updateSaleRejected(id).then(resultado => {
            Swal.fire({
              title: 'Venta rechazada',
              text: 'La venta no pudo finalizarse, intenta de nuevo',
              icon: 'error',
              allowOutsideClick: false,
              showCloseButton: true
            });
          });
        }
      });
    });
  }
  updateLocalStorage(){
    localStorage.setItem('dataCarShopTorreonMarket', JSON.stringify(this.carrito));
  }
}
